import { loanOptionApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_OPTION_TYPE = createNamedActions('loanOptionType', {
  GET_LOAN_OPTION_CONFIGURATION: 'GET_LOAN_OPTION_CONFIGURATION',
});

export const getLoanOptionConfigurationAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanOptionApi.getConfiguration(params);

  return dispatch({
    type: LOAN_OPTION_TYPE.GET_LOAN_OPTION_CONFIGURATION,
    payload: data,
  });
});
